import { Pipe, PipeTransform } from "@angular/core";
import { ClientData } from "../../providers/client";

@Pipe({
  name: "client"
})
export class ClientPipe implements PipeTransform {

  constructor(
    private clientData: ClientData
  ) { }

  transform(idClient: string) {
    return this.clientData.getClientConfigObservable(idClient);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/client/client.ts